import SubmissionStatus from '../Data/SubmissionStatus';
import { setPartialSubmissionStatus } from '../Lib/redux/slices/submission';
import { getSubmissionArgs } from './submission';
import { submitStandardLeadWithPartialData } from './submitLead.helpers';

const submitPartialLead = ({
  campaignId,
  components,
  consentedLegalStatementHash,
  countryCode,
  dispatch,
  formId,
  oneTrustLocale,
  pageUrl,
  parentPageCookies,
  phoneNumberCountryCode,
  referrerUrl,
  sourceSite,
  submitLeadMutation,
  testMode,
  useCidFromURL,
  widgetLabel,
  shouldShowMatchInLegalStatement,
  singleSupplierConsentedLegalStatementHash,
  showMultiSupplierMatchStatement,
  multipleSupplierConsentedLegalStatementHash,
  consentCertification,
  supplierId,
  visitorId,
  consentStatement,
  privacyPolicyUrl,
  subcategoryName,
  firstSubmissionAttemptTimestamp,
  subcategoryId,
  matchLevel,
  selectAndConnectBrand,
  iFrameId,
  partialSubmissionPage,
  supplierMatchSelectionEnabled,
}) => {
  dispatch(
    setPartialSubmissionStatus({
      partialSubmissionStatus: SubmissionStatus.IN_PROGRESS,
    })
  );

  const submissionArgs = getSubmissionArgs({
    campaignId,
    components,
    consentedLegalStatementHash,
    consentedSuppliersHash: '',
    countryCode,
    formId,
    phoneNumberCountryCode,
    sourceSite,
    testMode,
    pageUrl,
    referrerUrl,
    widgetLabel,
    useCidFromURL,
    parentPageCookies,
    oneTrustLocale,
    shouldShowMatchInLegalStatement,
    singleSupplierConsentedLegalStatementHash,
    showMultiSupplierMatchStatement,
    multipleSupplierConsentedLegalStatementHash,
    consentCertification,
    supplierId,
    consentStatement,
    privacyPolicyUrl,
    subcategoryName,
    subcategoryId,
    matchLevel,
    selectAndConnectBrand,
    isPartial: true,
    supplierMatchSelectionEnabled,
  });

  submitStandardLeadWithPartialData({
    submitLeadMutation,
    submissionArgs,
    dispatch,
    visitorId,
    firstSubmissionAttemptTimestamp,
    iFrameId,
    partialSubmissionPage,
  });
};

export default submitPartialLead;
